import { render } from "./sites.vue?vue&type=template&id=454d1c28&scoped=true"
import script from "./sites.vue?vue&type=script&lang=js"
export * from "./sites.vue?vue&type=script&lang=js"

import "./sites.vue?vue&type=style&index=0&id=454d1c28&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454d1c28"]])

export default __exports__